import { loadOptions } from '../../versa/formset.js';

/** Atendimento do pedido de entrada (#MT-58DB591) — qty pedida × entradas concluídas. */
export default function (...args)
{
	return {
		options: [
			{ value: 'pending', label: 'Pendente' },
			{ value: 'partial', label: 'Parcial' },
			{ value: 'total', label: 'Atendido total' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
